<template>
  <v-main class="wrapper">
    <v-container fluid>
      <v-row
        class="justify-space-evenly"
        align="center"
      >
        <v-col
          id="section-logo-nitro"
          class="bg-transparent d-flex align-center justify-center"
          cols="12"
          md="6"
        >
          <div
            id="container-logo-nitro"
            class="p-4"
          >
            <img
              id="icon"
              src="/images/logo_nitro_mobile.svg"
              alt="Logo Nitro"
            >
          </div>
        </v-col>
        <v-col
          id="section-form"
          cols="12"
          md="6"
        >
          <v-form
            id="form"
            ref="form"
          >
            <v-text-field
              v-model="form.email"
              :rules="emailRules"
              label="Email"
              outlined
              dense
              required
            />
            <v-text-field
              v-model="form.password"
              label="Senha"
              :rules="rules"
              required
              :append-icon="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
            />

            <div class="d-flex justify-content-center">
              <v-btn
                color="nitro"
                class="w-100 white--text"
                :disabled="is_loading"
                @click="onSubmit"
              >
                Entrar 
              </v-btn>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import { evolucional_redirect_url } from "@/constants/general";
import { redirect } from "@/utils/misc";

export default {
    data(){
        return {
            form : {
                email: '',
                password: '',
            },
            rules: [],
            showPassword: false,
            emailRules: [],
            is_loading: false,
        }
    },
    created(){
      if(this.isNotInDevelop){
        redirect(evolucional_redirect_url);
      }
    },
    mounted(){
      this.form.password = this.isInDevelop ? 123123123123 : ''
    },
    methods: {
      login(data){
        return axios.post(`/api/login`, data)
      },
      onSubmit(){
        this.is_loading = true
        this.login(this.form)
        .then(()=> {
          redirect('/')
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Erro',
            text: 'Erro ao realizar o login'
          })
          this.is_loading = false;
          return e
        })
      }
    }
}
</script>
<style lang="scss" scoped>

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        min-height: 100vh;
        padding: 20px;
        background: linear-gradient(to right, #060181, #F74A4B) !important;
    }

    #section-logo-nitro, #section-form {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 430px;
        min-height: 100%;
    }

    #container-logo-nitro {
        height: 212px;
        > img {
          width: 100%;
          height: 100%;
        }
    }

    @media screen and (max-width: 1000px) {
        .wrapper{
            flex-direction: column;
            justify-content: center;
        }
    }

    @media screen and (max-width: 767px) {
        #section-form, #section-logo-nitro{
            width: 300px;
        }
    }

    @media screen and (max-width: 600px) {
        #section-form, #section-logo-nitro{
            width: 283.83px;
        }
    }

    @media screen and (max-width: 314px) {
        #section-form, #section-logo-nitro{
            width: 80vw;
        }
    }
</style>
